// src/composables/useOverflowCheck.js
// 偵測左側sidebar按鈕的內容是否超出按鈕長度，有的話，給其加上跑馬燈的動畫
export default function useOverflowCheck () {
  function isOverflown (element) {
    return (
      element.scrollHeight > element.clientHeight ||
      element.scrollWidth > element.clientWidth
    )
  }
  function checkOverflown () {
    var els = document.getElementsByClassName('page-sidebar')
    for (var i = 0; i < els.length; i++) {
      var el = els[i]
      if (isOverflown(el)) {
        el.children[0].style.setProperty(
          '--overflowLen',
          -(el.scrollWidth - el.clientWidth + 15) + 'px'
        )
        el.style.webkitAnimation = 'none'
        el.style.webkitAnimation = ''
        el.className += ' marquee'
      }
    }
  }
  return {
    isOverflown,
    checkOverflown
  }
}
